module.exports = __webpack_public_path__ + "static/media/PW.667ce732.svg";